import { updateCaseDocument, updateMedicalRecord } from '@/store';
import { CaseDocumentGdprStatus, DocumentStatus } from '@/utils';
import { api } from '../core';

export type GdprStartReviewResponse = null;

type GdprStartReviewProps = {
  documentId: string;
};

const gdprStartReviewApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postGdprStartReview: builder.mutation<GdprStartReviewResponse, GdprStartReviewProps>({
      query: ({ documentId }: GdprStartReviewProps) => ({
        url: `gdpr/start-review`,
        method: 'POST',
        body: {
          documentId: documentId,
        },
      }),
      async onQueryStarted({ documentId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          // Start-review can only be called once per document, so mark the row as started
          // without waiting for a refetch. The next click then resumes the check instead.
          const checkStarted = new Date().toISOString();
          dispatch(
            updateCaseDocument({ documentId, status: CaseDocumentGdprStatus.GDPR_CHECK_IN_PROGRESS, checkStarted }),
          );
          dispatch(
            updateMedicalRecord({ documentId, documentStatus: DocumentStatus.GDPR_CHECK_IN_PROGRESS, checkStarted }),
          );
        } catch (error) {
          console.error('Error in postGdprStartReview in onQueryStarted:', error);
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { usePostGdprStartReviewMutation } = gdprStartReviewApi;
